import {UI} from "../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../stem-core/src/decorators/Style";
import {isSmallScreen} from "../../UtilsLib";
import {iFrameState} from "../../services/IFrameState";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {PanelLink, redirectOnClickLink, sanitizeUrlFromOptions} from "./Primitives";
import {merchantStyleRule} from "../Security";
import {MerchantButton, MerchantButtonStyle} from "../../common/MerchantButton";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient";


class PanelActionButtonStyle extends MerchantButtonStyle {
    @styleRule
    button = {
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: 0,
        width: "100%",
        maxWidth: isSmallScreen() ? "" : 300,
        padding: 12,
        display: "block",
        textAlign: "center",
        " svg": {
            transform: "translateY(2.8px)",
        },
        " svg g": {
            fill: this.themeProps.PAYWALL_BUTTON_LOGO_FILL + " !important",
        },
    };

    @merchantStyleRule
    pgActionButtonStyle = {
        ...iFrameState.actionButtonStyle,
    };
}

@registerStyle(PanelActionButtonStyle)
export class PanelActionButton extends UI.Primitive(MerchantButton, "a") {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.button);
        attr.addClass(this.styleSheet.pgActionButtonStyle);
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => dispatchAnalyticsEvent(AnalyticsEventType.ELEMENT_CLICK));
    }
}

export function PanelActionButtonBuilder(ControllerClass) {
    return (options, children) => {
        const controller = new ControllerClass();
        options = {
            label: controller.getActionButtonDefaultLabel(),
            anid: controller.actionButtonDefaultAnid,
            testId: controller.actionButtonTestId,
            ...options,
        };
        options.value = options.label;
        options.onClick = (e) => controller.onClick(e);
        if (options.href) {
            sanitizeUrlFromOptions(options, "href");
            options.onClick = redirectOnClickLink;
            if (options.newTab) {
                options.target = "_blank";
            }
        }
        if (options.link) {
            return <PanelLink {...options}>
                {children}
            </PanelLink>;
        }
        return <PanelActionButton {...options}>
            {children}
        </PanelActionButton>;
    };
}
